import { getMediaLightboxCurrentItem } from '@ms/yammer-data/dist/domains/mediaLightbox/selectors';
import type { YammerState } from '@ms/yammer-data/dist/state/types';
import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';

import type { MappedStateProps } from './LazyMediaLightbox';
import LazyMediaLightbox from './LazyMediaLightbox';

export const mapStateToProps: MapStateToProps<MappedStateProps, Record<string, unknown>, YammerState> = (state) => ({
  isShowing: !!getMediaLightboxCurrentItem(state),
});

export default connect(mapStateToProps)(LazyMediaLightbox);
